<template>
<div>
    <Breadcrumbs main="HR" submain="Leave Management" title="Leave Type" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Leave Type</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">

                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                      
                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                
                                <b-table show-empty stacked="md" :items="leave_type" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(active)="row">
                                        <span v-if="row.value == true">
                                            <b-badge pill variant="success">Active</b-badge>
                                        </span>
                                        <span v-if="row.value == false">
                                            <b-badge pill variant="danger">Inactive</b-badge>
                                        </span>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteLeaveType(data.item.id)" title="Delete"></feather>
                                            <div @click="editType(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                        <div v-else>
                            <div class="loader-box">
                                <div class="loader-10"></div>
                            </div>
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Leave Type Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Leave Type" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group label="Title" label-for="name-input">
                <b-form-input v-model="leave.name" placeholder="Enter leave title"></b-form-input>
            </b-form-group>

            <b-form-group label="Days" label-for="name-input">
                <b-form-input type="number" v-model="leave.days" placeholder="Enter number of days"></b-form-input>
            </b-form-group>

            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="leave.active" :options="statusOptions"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>

    <!-- Leave Type Edit Modal -->

    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Leave Type" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <b-form-group label="Title" label-for="name-input">
                <b-form-input v-model="edit_leave.name" placeholder="Enter leave title"></b-form-input>
            </b-form-group>

            <b-form-group label="Days" label-for="name-input">
                <b-form-input type="number" v-model="edit_leave.days" placeholder="Enter number of days"></b-form-input>
            </b-form-group>

            <b-form-group label="Status" label-for="name-input">
                <b-form-select v-model="edit_leave.active" :options="statusOptions"></b-form-select>
            </b-form-group>
        </form>
    </b-modal>
    <!-- Leave type delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this leave type?</div>
    </b-modal>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import moment from "moment";
import {
    mapState
} from 'vuex';

export default {
    data() {
        return {

            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'days',
                    label: 'Days',
                    sortable: true
                },
                {
                    key: 'active',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            statusOptions: [{
                    text: 'Active',
                    value: true
                }, // Assign true when Option 1 is selected
                {
                    text: 'Inactive',
                    value: false
                } // Assign false when Option 2 is selected
            ],

            delete_value: '',

            leave: {
                name: '',
                days: null,
                active: '',
            },

            edit_leave: {
                id: '',
                name: '',
                days: null,
                active: null
            },

            filter: null,

            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            pageOptions: [25, 50, 100],

            temp_quotation: {}
        };
    },

    computed: {
        ...mapState({
            leave_type: state => state.leave.leaveTypeList,
            loading: state => state.leave.submitLoading,
            error: state => state.leave.submitError,

        }),
      
    },

    mounted() {
        this.$store.dispatch("leave/fetchLeaveType",{}).then(() => {
            this.items = this.leave_type
            this.totalRows = this.items.length;

        });

    },

    methods: {

        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.leave.name = ''
            this.leave.days = null
            this.leave.status = ''
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {

            this.$store.dispatch("leave/addLeaveType", this.leave).then(response => {

                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.leave.name = '',
                        this.leave.days = '',
                        this.leave.status = ''

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editType(type) {
            this.edit_leave.id = type.id
            this.edit_leave.name = type.name
            this.edit_leave.days = type.days
            this.edit_leave.active = type.active
        },

        resetEditModal() {
            this.edit_leave.title = ''
            this.edit_leave.days = null
            this.edit_leave.status = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("leave/updateLeaveType", {
                id: this.edit_leave.id,
                name: this.edit_leave.name,
                days: this.edit_leave.days,
                active: this.edit_leave.active,

            }).then(response => {

                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.edit_leave.name = '',
                        this.edit_leave.days = '',
                        this.edit_leave.active = ''

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteLeaveType(id) {
            this.delete_value = id
        },
        handleDeleteOk() {
            this.$store.dispatch("leave/deleteLeaveType", this.delete_value).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
